namespace Application.Models {
    'use strict';

    export declare type AlarmLevelValue = number | string | boolean;
    export declare type AlarmConfigType = 'number' | 'string' | 'boolean' | 'relay';

    export interface IAlarmLevel {
        id?: number;
        alarm_config_id?: number;
        numOrder?: number;
        masked?: boolean;
        value?: AlarmLevelValue;
        emailAlert?:boolean;
    }

    export interface IAlarmConfig {
        id?: number;
        deviceId?: number;
        paramName?: string;
        enabled?: boolean;
        type?: AlarmConfigType;
        description?: string;
        unit?: string;
        masked?: boolean;
        levels?: IAlarmLevel[];
        stringComparison?: 'contains' | 'equals';
        hysteresis?: number;
        emailAlert?:boolean;
        options?: IAlarmParamOption[];
    }

    export interface IDeviceAlarmConfig {
        id: number;
        deviceHref: string;
        alarmConfigs: IAlarmConfig[];
        condition: string;
    }

    export interface IAlarmParamOption {
        value: number | string | boolean;
        description: string;
    }

    export interface IConditionAlarmConfigMap {
        [key: string]: IDeviceAlarmConfig;
    }
}